import React, { useState } from 'react';
import 'twin.macro';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useFormState } from 'react-final-form';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { Pyramide, PyramidePDFSettings } from 'types/pyramide';
import { buildPyramideParams } from 'containers/PyramidesDesAges/Pyramide/buildPyramideParams';

interface Props {
  pyramide: Pyramide;
  lng: UserLocale;
  groups?: string[];
}

export function Body(props: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { pyramide, lng, groups } = props;
  const { values: settings } = useFormState<PyramidePDFSettings>();

  const url = new URL(
    `/print/annee-scolaire/${schoolyear.id}/ecole/${school.id}/pyramide-des-ages/${pyramide.id}`,
    window.location.origin,
  );

  url.search = buildPyramideParams({
    lng,
    settings,
    groups,
    pyramide,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildPyramideParams({
      lng,
      settings,
      groups,
      pyramide,
    }),
  });

  const landscape = settings.layout !== 'byEleves';
  return (
    <IframePreviewPDF
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
      landscape={landscape}
    />
  );
}
